import React from 'react'
import PropTypes from 'prop-types'

const ConfirmTransferModal = ({ summary, counts, isSubmitting, onConfirm, onCancel }) => {
    return (
        <div className="font-sans">
            <h1 className="text-2xl font-bold mb-2">Confirm transfer</h1>
            <p className="text-sm text-gray-700 mb-4">{summary}</p>

            <div className="grid grid-cols-2 gap-3 mb-4">
                <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-500">Leads matched</div>
                    <div className="text-lg font-semibold text-gray-900">{counts.leadsMatched}</div>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-500">Leads to transfer</div>
                    <div className="text-lg font-semibold text-gray-900">{counts.leadsToTransfer}</div>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-500">Opportunities to transfer</div>
                    <div className="text-lg font-semibold text-gray-900">{counts.opportunitiesToTransfer}</div>
                </div>
                <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-500">Tasks to transfer</div>
                    <div className="text-lg font-semibold text-gray-900">{counts.tasksToTransfer}</div>
                </div>
            </div>

            <p className="text-sm font-semibold text-red-600 mb-4">This cannot be undone.</p>

            <div className="flex justify-end gap-3">
                <button
                    type="button"
                    onClick={onCancel}
                    disabled={isSubmitting}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    disabled={isSubmitting}
                    className="px-4 py-2 text-sm font-medium text-white-50 bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50"
                >
                    {isSubmitting ? 'Starting…' : 'Yes, transfer'}
                </button>
            </div>
        </div>
    )
}

ConfirmTransferModal.propTypes = {
    summary: PropTypes.string.isRequired,
    counts: PropTypes.shape({
        leadsMatched: PropTypes.number,
        leadsToTransfer: PropTypes.number,
        opportunitiesToTransfer: PropTypes.number,
        tasksToTransfer: PropTypes.number,
    }).isRequired,
    isSubmitting: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
}

ConfirmTransferModal.defaultProps = {
    isSubmitting: false,
}

export default ConfirmTransferModal
